import {
  LineChart, Rocket, Search, TrendingUp, Users, Sparkles, Network, ArrowUpRight,
} from "lucide-react";
import AudiencePageShell from "../components/AudiencePageShell";
import SeoHead from "../components/SeoHead";

export default function PourLesInvestisseurs() {
  return (
    <>
    <SeoHead
      title="Pour les investisseurs · Le deal flow panafricain qualifié"
      description="AFRICTAL révèle les projets africains les plus prometteurs. Accédez à un deal flow qualifié, des porteurs de projets accompagnés et un écosystème panafricain qui accélère vos décisions d'investissement."
      path="/pour-les-investisseurs"
      keywords="investissement Afrique, deal flow, venture capital, startups africaines, projets qualifiés"
    />
    <AudiencePageShell
      testIdRoot="afr-audience-investisseurs"
      breadcrumb={{ label: "Investisseurs" }}
      eyebrow="Pour les investisseurs"
      accentColor="var(--mod-investissement)"
      heroTitle={<>Investissez dans les projets qui <em>construiront l'Afrique de demain.</em></>}
      heroText={
        "AFRICTAL facilite la rencontre entre investisseurs, entrepreneurs et porteurs de projets en mettant en avant des initiatives porteuses de valeur et d'impact."
      }
      ctaPrimary={{ label: "Découvrir les projets", to: "/login?mode=signup&role=investisseur", icon: LineChart }}
      ctaSecondary={{ label: "Créer un compte", to: "/login?mode=signup&role=investisseur" }}

      servicesTitle="Les solutions pour les investisseurs"
      servicesLead="Un deal flow curé, structuré et directement accessible."
      services={[
        { icon: LineChart,   title: "Découvrir des projets prometteurs",       desc: "Un flux d'opportunités qualifiées, filtrées par secteur, stade de maturité et impact." },
        { icon: Rocket,      title: "Rechercher des startups",                  desc: "Explorez les startups africaines qui redessinent leur industrie." },
        { icon: Search,      title: "Identifier des opportunités d'investissement", desc: "Repérez les projets qui correspondent à votre thèse d'investissement." },
        { icon: Users,       title: "Échanger avec les entrepreneurs",          desc: "Une messagerie sécurisée pour dialoguer directement avec les porteurs de projet." },
        { icon: TrendingUp,  title: "Suivre les opportunités",                  desc: "Tableau de bord dédié pour suivre l'évolution des projets qui vous intéressent." },
        { icon: Network,     title: "Développer un réseau d'investissement",    desc: "Rejoignez une communauté d'investisseurs africains et de la diaspora." },
      ]}

      stepsTitle="Comment ça fonctionne"
      steps={[
        "Créer un compte",
        "Découvrir les projets disponibles",
        "Analyser les opportunités",
        "Entrer en contact avec les entrepreneurs",
        "Investir et suivre l'évolution des projets",
      ]}

      whyTitle="Un pont entre les capitaux et l'innovation africaine"
      whyText={
        "AFRICTAL met en relation les investisseurs avec des entrepreneurs, startups et projets innovants dans différents secteurs d'activité afin de favoriser le développement économique et l'innovation en Afrique. Chaque projet est vérifié et présenté avec transparence pour vous permettre d'analyser rapidement les opportunités qui comptent."
      }

      ctaFinalTitle="Les grandes opportunités commencent par une rencontre. AFRICTAL vous aide à découvrir les projets qui feront la différence."
      ctaFinalPrimary={{ label: "Découvrir les projets", to: "/login?mode=signup&role=investisseur", icon: LineChart }}
      ctaFinalSecondary={{ label: "Créer un compte", to: "/login?mode=signup&role=investisseur" }}
    />
    </>
  );
}
